export function useCreateMarketingRenderingHame(renderingName: string): string {
  const spaceDash = /(\d+)(?=[A-Z])/g;
  // Split where an uppercase letter is followed by an uppercase sequence optionally ending with 's', then a capital + lowercase word
  const splitCapsBeforeLowerPlural = /([A-Z]+s?(?=[A-Z][a-z]))/g;
  // Split lowercase letter before uppercase letter (normal word splits)
  const splitLowerBeforeCaps = /([a-z])([A-Z])/g;
  // Refactor this out in the future CTAs gets split like CT As but we want CTAs
  const splitCTA = /CT As$/g;

  const marketingName = renderingName
    .replace(spaceDash, '$1 - ')
    .replace(splitCapsBeforeLowerPlural, '$1 ')
    .replace(splitLowerBeforeCaps, '$1 $2')
    .replace(splitCTA, 'CTAs')
    .replace(/\s+/g, ' ')
    .trim();
  return marketingName;
}
